document.addEventListener('DOMContentLoaded', () => {

  const tabs = document.querySelectorAll('.cf-tab');
  const panels = document.querySelectorAll('.cf-tab-panel');

  const mobileToggle = document.querySelector('.cf-mobile-tab-toggle');
  const mobileMenu = document.querySelector('.cf-mobile-tab-menu');
  const mobileLabel = document.querySelector('.cf-mobile-tab-label');
  const mobileItems = document.querySelectorAll('.cf-mobile-tab-menu button');

  function activateTab(tabName) {

    tabs.forEach(tab => {
      tab.classList.toggle('is-active', tab.dataset.tab === tabName);
    });

    panels.forEach(panel => {
      panel.hidden = panel.id !== 'cf-tab-' + tabName;
    });

    if (mobileLabel) {

      const activeItem = document.querySelector(
        '.cf-mobile-tab-menu button[data-tab="' + tabName + '"]'
      );

      if (activeItem) {
        mobileLabel.textContent = activeItem.textContent.trim();
      }

    }

    if (mobileMenu) {
      mobileMenu.hidden = true;
    }

    if (mobileToggle) {
      mobileToggle.setAttribute('aria-expanded', 'false');
    }

  }

  /* Desktop tabs */

  tabs.forEach(tab => {

    tab.addEventListener('click', () => {

      activateTab(tab.dataset.tab);

    });

  });

  /* Mobile dropdown */

  if (mobileToggle) {

    mobileToggle.addEventListener('click', () => {

      const expanded =
        mobileToggle.getAttribute('aria-expanded') === 'true';

      mobileToggle.setAttribute(
        'aria-expanded',
        (!expanded).toString()
      );

      mobileMenu.hidden = expanded;

    });

  }

  mobileItems.forEach(item => {

    item.addEventListener('click', () => {

      activateTab(item.dataset.tab);

    });

  });

  /* Navigation buttons */

  const navButtons = document.querySelectorAll('.cf-tab-nav-button');

  navButtons.forEach(button => {

    button.addEventListener('click', () => {

      activateTab(button.dataset.tab);

      window.scrollTo({
        top: document.querySelector('.cf-product-tabs').offsetTop - 20,
        behavior: 'smooth'
      });

    });

  });

});

document.addEventListener("DOMContentLoaded", function () {

  const expandButtons = document.querySelectorAll(".cf-expand-toggle");

  expandButtons.forEach(function (button) {

    const wrapper = button.closest(".cf-expandable-wrapper");
    const content = wrapper.querySelector(".cf-expandable-content");
    const text = button.querySelector(".cf-expand-text");
    const icon = button.querySelector(".cf-expand-icon");

    button.addEventListener("click", function () {

      const expanded = content.classList.toggle("expanded");

      if (expanded) {
        text.textContent = "Vezi mai puțin";
        icon.textContent = "▲";
      } else {
        text.textContent = "Vezi mai mult";
        icon.textContent = "▼";
      }

    });

  });

});